module.exports = __webpack_public_path__ + "static/media/4_r_fripulia_82.5_32.5.77b57b37.png";